module.exports = __webpack_public_path__ + "static/iniciar-sesion-text-b0d45efa389a3c105b832a666cfdd702.png";